const buildQueryString = obj => {
  const keys = Object.keys(obj);
  if (keys.length === 0) {
    return null;
  }

  const len = keys.length;
  const params = [];
  for (let i = 0; i < len; i += 1) {
    const key = keys[i];
    const value = obj[key];
    if (value) {
      params.push(`${key}=${value}`);
    }
  }

  return encodeURI(params.join('&'));
};

export default buildQueryString;
